import {
  Card, CardBody, CardFooter,
} from "@heroui/react";
import type { CSSProperties, FC } from "react";
import type { IComponentBaseProps } from "@/shared/config";
import { useCN } from "@/shared/lib/hooks";
import type { IProductivity } from "../config";

/**
 * Блок преимуществ
 * @constructor
 */
export const Productivity: FC<IProductivity & IComponentBaseProps> = ({
  baseClass = "banner",
  productivityItems = [],
}) => {

  const { getCN } = useCN(baseClass);
  const headingTightSpacing = {
    "--heading-margin-desktop": "0",
    "--heading-margin-tablet": "0",
    "--heading-margin-mobile": "0",
    "--heading-line-height": "1",
  } as CSSProperties;
  const headingGradient = {
    ...headingTightSpacing,
    "--heading-font-weight": "700",
  } as CSSProperties;

  return (
    <div className={"flex flex-col items-center text-center mx-w-90 h-auto mx-auto gap-[8rem] mobile:gap-5 mobile:max-w-100"}>
      <div className={"flex flex-col items-center text-center max-w-[100rem] mx-auto"}>
        <h2 style={headingTightSpacing} className={"!text-[var(--color-white)]"}>
          Here’s how you reach
        </h2>
        <h2 style={headingGradient} className={getCN("title", {}, [ "isGradientText" ])}>
          10x productivity
        </h2>
      </div>
      <ul className={"flex w-full mobile:flex-col gap-6 tablet:gap-4 mobile:gap-2"}>
        {productivityItems.map((item, index) => (<li key={index} className={item.utilClasses}>
          <Card className={"relative rounded-[3rem] bg-[var(--color-lightGray)] h-full min-h-100 mobile:min-h-60 mobile:h-60"}>
            <CardBody className={"p-0 relative h-full overflow-hidden "}>
              <div className={"absolute isGradient"} />
              <picture className={"block w-full h-full"}>
                <source srcSet={item.img.desktop} media={"(min-width: 769px)"} />
                <source srcSet={item.img.mobile} media={"(max-width: 768px)"} />
                <img
                  draggable={false}
                  src={item.img.desktop}
                  alt={item.img.alt}
                  className={"block w-full h-auto object-cover object-top"}
                  loading={"lazy"}
                />
              </picture>
            </CardBody>
            <CardFooter className={"absolute bottom-0 left-0 right-0 px-10 tablet:px-5 pb-11 flex-col gap-2 items-start text-white pt-0 mobile:gap-0 rounded-none mt-aut mobile:px-4 mobile:pb-4"}>
              <h6 className={"text-left font-semibold pb-2 leading-[normal]"}>{item.title}</h6>
              <p className={"text-left subtitile text-white-70 leading-[normal]"}>{item.desc}</p>
            </CardFooter>
          </Card>
        </li>))}
      </ul>
    </div>
  );
};
